export default __webpack_public_path__ + "static/media/msg5white.db97963e.svg";